import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'

interface UseContractEnvelopeSendToRemoteSignServiceProps {
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

export const useContractEnvelopeSendToRemoteSignService = ({
  onSuccess,
  onError,
}: UseContractEnvelopeSendToRemoteSignServiceProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['contractEnvelopeSendToRemoteSignService'],
    mutationFn: async (id: string) => {
      await privateAxios.put(`/funnel/private_company_leads/${id}/send_contract_to_remote_sign_service`)
    },
    onSuccess,
    onError,
  })
}
